<script>
export default {
  props: {
    icon: { type: String, default: 'mdi-magnify' },
    placeholder: { type: String, default: 'press enter to submit' },
    backgroundExpanded: { type: String, default: 'primary darken-2' },
    backgroundCollapsed: { type: String, default: 'primary' },
    iconExpanded: { type: String, default: 'rgba(255,255,255, 0.5)' },
    iconCollapsed: { type: String, default: 'white' },
    emit: { type: String, default: '' },
  },
  data() {
    return {
      search: '',
      expanded: false,
    }
  },
  methods: {
    async submit() {
      const payload = this.search.trim()
      if (payload?.length) {
        this.search = ''
        this.expanded = false
        this.$emit(this.emit, payload)
      }
    },
  },
}
</script>

<template>
  <div class="d-flex align-center rounded">
    <v-text-field
      v-if="$vuetify.breakpoint.mdAndUp"
      v-model="search"
      clearable
      dense
      hide-details
      solo
      flat
      dark
      :background-color="expanded ? backgroundExpanded : backgroundCollapsed"
      :placeholder="expanded ? placeholder : ''"
      class="search"
      :class="{
        'collapsed-input': !expanded,
        'expanded-input': expanded,
      }"
      @click:clear="expanded = false"
      @blur="expanded = false"
      @keyup.enter="submit"
    >
      <template v-slot:prepend-inner>
        <v-icon
          class="cursor-pointer h-full"
          :color="expanded ? iconExpanded : iconCollapsed"
          @click="expanded = !expanded"
        >
          {{ icon }}
        </v-icon>
      </template>
    </v-text-field>

    <v-text-field
      v-else
      clearable
      dense
      hide-details
      solo
      flat
      dark
      :background-color="backgroundCollapsed"
      :placeholder="placeholder"
      class="search pl-2"
      @keyup.enter="submit"
    ></v-text-field>
  </div>
</template>

<style scoped>
.search {
  height: 40px;
  transition: all ease 0.3s;
}

.expanded-input {
  width: 350px;
}

.collapsed-input {
  width: 48px;
}

.cursor-pointer {
  cursor: pointer;
}

.collapsed-input >>> .v-input__slot {
  cursor: pointer !important;
}
</style>
